export interface IGiftActions {
  id: number;
  giftType: EGiftType;
  idActionBody: number;
  minCount: number;
  minSum: number;
  choose: number;
  assignGiftList: IGift[];
  expandInCart: boolean;
  hideInCart: boolean;
}

export interface IGift {
  availability: number;
  brand: string;
  code: string;
  collection: string;
  idAssign: number;
  image: string;
  itemId: number;
  language: string;
  productId: number;
  selected: boolean;
  subName: string;
}

export enum EGiftType {
  SPECIAL = 'Special',
  SAMPLE = 'Sample',
  TRY_IT_FIRST = 'TryItFirst',
  BASIC = 'Basic',
  NEW_CUSTOMER = 'NewCustomer',
  GWP = 'Gwp',
}
